import * as angular from 'angular';
import * as _ from 'lodash';
import ResourceService from './resource.service';
import SiteResource from '../models/site-resource';

export default class SiteService extends ResourceService<SiteResource> {
  constructor(private BackendService: any) {
    super(BackendService, SiteResource);
  }
}

angular.module('ciApp.services').service('SiteService', ['BackendService', SiteService]);



// WEBPACK FOOTER //
// ./common/services/site.service.ts